export const loadOfflineImage = async () => {
  const image = await import('../../../assets/website/images/offline.webp');
  return image.default;
};

export const scheduleOfflineImageLoad = (onLoad) => {
  const loadImage = () => {
    loadOfflineImage()
      .then(onLoad)
      .catch(() => onLoad(null));
  };

  if ('requestIdleCallback' in window) {
    const idleCallbackId = window.requestIdleCallback(loadImage);
    return () => window.cancelIdleCallback(idleCallbackId);
  }

  const timeoutId = window.setTimeout(loadImage, 1500);
  return () => window.clearTimeout(timeoutId);
};
